import { newSlice,_fetchEntitiesService,_loadEvents,_createEntityService,_updateEntityService,_deleteEntityService} from "../../../redux/slices/common/sliceFunctions";

var entitiesName = 'messages';

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

export function fetchEntitiesService(dataSlice) {
  dataSlice.dataUrl.code="GET_MSG";
  return _fetchEntitiesService(dataSlice,events);
}
export function showEntitiesService(dataSlice) {
  dataSlice.dataUrl.code="SHOW_MSG";
  return _fetchEntitiesService(dataSlice,events);
}
export function createEntityService(dataSlice) {
  dataSlice.dataUrl.code="POST_MSG";
  return _createEntityService(dataSlice,events);
}

export function fetchPortalEntitiesService(dataSlice) {
  dataSlice.dataUrl.code="GET_PORTAL_MSG";
  return _fetchEntitiesService(dataSlice,events);
}

export function showPortalEntitiesService(dataSlice) {
  dataSlice.dataUrl.code="SHOW_PORTAL_MSG";
  return _fetchEntitiesService(dataSlice,events);
}

export function createPortalEntityService(dataSlice) {
  dataSlice.dataUrl.code="POST_PORTAL_MSG";
  return _createEntityService(dataSlice,events);
}
